var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50012 17.0001C6.32855 17.0001 7.00012 16.3286 7.00012 15.5001C7.00012 14.6717 6.32855 14.0001 5.50012 14.0001C4.67169 14.0001 4.00012 14.6717 4.00012 15.5001C4.00012 16.3286 4.67169 17.0001 5.50012 17.0001Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 2.99999H5C3.67441 3.00158 2.40356 3.52887 1.46622 4.46621C0.528882 5.40355 0.00158786 6.6744 0 7.99999L0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21H19C20.3256 20.9984 21.5964 20.4711 22.5338 19.5338C23.4711 18.5964 23.9984 17.3256 24 16V7.99999C23.9984 6.6744 23.4711 5.40355 22.5338 4.46621C21.5964 3.52887 20.3256 3.00158 19 2.99999ZM5 4.99999H19C19.7956 4.99999 20.5587 5.31606 21.1213 5.87867C21.6839 6.44128 22 7.20434 22 7.99999H2C2 7.20434 2.31607 6.44128 2.87868 5.87867C3.44129 5.31606 4.20435 4.99999 5 4.99999ZM19 19H5C4.20435 19 3.44129 18.6839 2.87868 18.1213C2.31607 17.5587 2 16.7956 2 16V9.99999H22V16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlack);
export default __webpack_public_path__ + "static/media/credit-card-black.eca1d582fbb3cd1fa040925d69058692.svg";
export { ForwardRef as ReactComponent };